import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './custom-html.scss';
import { Provider, observer } from 'mobx-react';
import { configure } from 'mobx';
import RootStore from './store/RootStore';
import * as serviceWorker from './serviceWorker';
import Main from './main';
import * as moment from 'moment';
import 'moment/locale/zh-cn';
import ThemeProvider from './store/ThemeProvider';

moment.locale('zh-cn');

configure({
  enforceActions: 'observed'
});

@observer
class Index extends React.Component {
  render() {
    return (
      <Provider rootStore={new RootStore()}>
        <ThemeProvider>
          <Main />
        </ThemeProvider>
      </Provider>
    );
  }
}

ReactDOM.render(<Index />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
